module.exports = __webpack_public_path__ + "static/media/Excellence.4ea3e665.jpg";